<template>
  <v-navigation-drawer
    id="default-drawer"
    v-model="drawer"
    :dark="dark"
    :right="$vuetify.rtl"
    :src="showImage ? image : ''"
    :mini-variant.sync="mini"
    mini-variant-width="80"
    app
    width="260"
  >
    <template
      v-if="showImage"
      #img="props"
    >
      <v-img
        :key="image"
        :gradient="gradient"
        v-bind="props"
      />
    </template>

    <div class="px-2">
      <default-drawer-header />

      <v-divider class="mx-3 mb-2" />

      <default-list :items="visibleItems" />
    </div>
    <div class="pt-12" />
  </v-navigation-drawer>
</template>

<script>
  // Utilities
  import { get, sync } from 'vuex-pathify'

  export default {
    name: 'DefaultDrawer',

    components: {
      DefaultDrawerHeader: () => import(
        /* webpackChunkName: "default-drawer-header" */
        './widgets/DrawerHeader'
      ),
      DefaultList: () => import(
        /* webpackChunkName: "default-list" */
        './List'
      ),
    },

    data () {
      return {
        visibleItems: [],
      }
    },

    computed: {
      ...get('user', [
        'dark',
        'gradient',
        'image',
        'images',
      ]),
      ...get('app', [
        'items',
        'version',
        'node_environment',
      ]),
      ...sync('app', [
        'drawer',
        'mini',
      ]),
      users: get('user/users'),
      showImage () {
        let showIt = false

        if (this.users.settings) {
          showIt = this.users.settings.show_image
        }

        return showIt
      },
    },

    mounted () {
      // intercept items before the Drawer is rendered
      let parentItem = {}

      this.visibleItems = []

      // TODO: This won't work if app.items ever go more than 1 level deep
      for (const appItem of this.items) {
        if (appItem.visible) {
          parentItem = { ...appItem }

          if (appItem.items) {
            parentItem.items = []

            for (const childItem of appItem.items) {
              if (childItem.visible) {
                parentItem.items.push({ ...childItem })
              }
            }
          }

          this.visibleItems.push(parentItem)
        }
      }
    },
  }
</script>

<style lang="sass">
#default-drawer
  .v-list-item
    margin-bottom: 8px

  .v-list-item::before,
  .v-list-item::after
    display: none

  .v-list-group__header__prepend-icon,
  .v-list-item__icon
    margin-top: 12px
    margin-bottom: 12px
    margin-left: 4px

  &.v-navigation-drawer--mini-variant
    .v-list-item
      justify-content: flex-start !important

  @media print
    display: none !important
    visibility: hidden !important
</style>
